import { render, staticRenderFns } from "./DropdownArrow.vue?vue&type=template&id=2006c469&scoped=true"
import script from "./DropdownArrow.vue?vue&type=script&lang=js"
export * from "./DropdownArrow.vue?vue&type=script&lang=js"
import style0 from "./DropdownArrow.vue?vue&type=style&index=0&id=2006c469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006c469",
  null
  
)

export default component.exports